export default __webpack_public_path__ + "static/application-4da50fdbcc0df54e80cc158e742294d6.png";